import PlayerRolesCard from './PlayerRolesCard.svelte';

!customElements.get('player-roles-card') && customElements.define('player-roles-card', PlayerRolesCard);
export default PlayerRolesCard;
